import ModalDel from './modal-cancel.component'

export default ModalDel
